// extracted by mini-css-extract-plugin
export default {"link":"AfaDocumentacionLink_link__tNlFh"};